import { useEffect } from 'react';
import { RESTING_DOM_CHARS } from '../utils/nestedHtml';
import { placeCaretBeforeTail } from '../utils/placeFieldCaret';

/** Keep the field in step with the stored value, undo, and autofocus. */
export function useNestedValueSync({
  elRef,
  value,
  paint,
  resolveVariable,
  historyEpoch,
  autoFocus,
  readOnly,
  focusedRef,
  lastCommittedRef,
  pickerOpenRef,
  slashOpenRef,
}) {
  useEffect(() => {
    if (focusedRef.current || pickerOpenRef.current || slashOpenRef.current) return;
    const next = value || '';
    lastCommittedRef.current = next;
    paint(next);
  }, [value, paint, resolveVariable, focusedRef, lastCommittedRef, pickerOpenRef, slashOpenRef]);

  // DocEditor undo/redo — adopt restored value even while focused
  useEffect(() => {
    const next = value || '';
    lastCommittedRef.current = next;
    paint(next);
  }, [historyEpoch]); // eslint-disable-line react-hooks/exhaustive-deps -- intentional

  useEffect(() => {
    if (!autoFocus || readOnly) return;
    const el = elRef.current;
    if (!el) return;
    el.focus();
    placeCaretBeforeTail(el);
  }, [autoFocus, readOnly, elRef]);
}
